<soft-edit-page>
  <soft-page-header>
    <soft-dynamic-object
      [definition]="$any(headerDefinition())"
      [value]="timeReport()"
    ></soft-dynamic-object>
  </soft-page-header>

  <soft-dynamic-form
    class="block mt-4"
    [value]="timeReport()"
    [definition]="$any(definition())"
    #form
    >
  </soft-dynamic-form>

  @if (timeReport(); as timeReport) {
    <section class="mt-5 mb-3">
      <h6 class="soft-overline colored condensed">
        {{ '#TIME_REPORT.FILES.HEADER' | translate }}
      </h6>
      <soft-archive-list
        [archiveKey]="timeReport?.archivekey || $any(timeReport)?.archivekey"
      ></soft-archive-list>
    </section>
    @if (
      timeReport?.group &&
      (timeReport?.group?.length ?? 0) > 0 &&
      (hasPartyPermission())
      ) {
      <section
        >
        <h6 class="soft-overline colored condensed mb-1 mt-4">
          {{ '#TIME_REPORT.COMPONENTS.EDIT.RECORDED_FOR' | translate }}
        </h6>
        <soft-chip-group>
          @for (person of timeReport?.group; track person) {
            <soft-chip
              style="margin-top: 0.25rem; margin-right: 0.25rem"
              [canDelete]="false"
              >
              {{ person?.vorname }} {{ person?.zuname }} ({{ person.persnr }})
            </soft-chip>
          }
        </soft-chip-group>
      </section>
    }
    <hr class="m-4" />
    @if (!timeReportConfig?.hideEntryInDetails) {
      <soft-dynamic-object
        class="mb-4"
        [value]="timeReport"
        >
      </soft-dynamic-object>
    }
    @if (timeReport?.object && timeReport?.object?.geodaten) {
      <div class="flex items-center justify-between mb-2 mt-6">
        <div class="text-xl font-semibold">
          {{ '#TIME_REPORT.COMPONENTS.EDIT.GEODATEN' | translate }}
        </div>
        <a
          target="_blank"
          class="soft-link"
          [attr.href]="getGoogleLink($safeNavigationMigration(timeReport?.object)!)"
          >{{ '#TIME_REPORT.COMPONENTS.EDIT.GEO_MAPS_LINK' | translate }}</a
          >
        </div>
        <section class="flex flex-row">
          <div
            class="soft-card soft-card-rounded w-full border-bottom divide-y divide-gray-200"
            style="padding: 0"
            >
            <div class="flex flex-row justify-between p-4">
              <div class="soft-container-column-start text-sm">
                <strong>{{ '#TIME_REPORT.COMPONENTS.EDIT.GPS_LAENGE' | translate }}</strong>
              </div>
              <div class="soft-contianer--column-end text-sm">
                {{ timeReport?.object?.geodaten?.gpslaenge || '-' }}
              </div>
            </div>
            <div class="flex flex-row justify-between p-4">
              <div class="soft-container-column-start text-sm">
                <strong>{{ '#TIME_REPORT.COMPONENTS.EDIT.GPS_BREITE' | translate }}</strong>
              </div>
              <div class="soft-contianer--column-end text-sm">
                {{ timeReport?.object?.geodaten?.gpsbreite || '-' }}
              </div>
            </div>
          </div>
        </section>
      }
    }
  </soft-edit-page>
